export default {
  error: 'Coś poszło nie tak',
  // MUTATIONS
  AddPeriodicEvent: 'Nie udało się utworzyć serii spotkań',
  AddSingleEvent: 'Nie udało się utworzyć spotkania',
  AddEmployeeWorkingHours: 'Nie udało się dodać godzin pracy pracownika',
  EditEvent: 'Nie udało się zaktualizować spotkania',
  EditAddress: 'Nie udało się zaktualizować adresu',
  CreateEmployee: 'Nie udało się utworzyć pracownika',
  CreateEmployeePreferredRooms: 'Nie udało się zaktualizować pracownika',
  CreateEmployeeRoles: 'Nie udało się zaktualizować pracownika',
  EditEmployee: 'Nie udało się zaktualizować pracownika',
  UpdateWorkingTimes: 'Nie udało się zaktualizować godzin pracy',
  AddGroup: 'Nie udało się utworzyć grupy',
  AddGroupMembers: 'Nie udało się dodać członków grupy',
  DeactivateGroup: 'Nie udało się dezaktywować grupy',
  AddCouple: 'Nie udało się utworzyć par',
  AddPatient: 'Nie udało się utworzyć pacjenta',
  DeactivatePatient: 'Nie udało się dezaktywować pacjenta',
  EditPatient: 'Nie udało się zaktualizować pacjenta',
  AddPatientPsychotherapy:
    'Nie udało się zaktualizować notatek psychoterapii pacjenta',
  EditPatientPsychotherapy:
    'Nie udało się zaktualizować notatek psychoterapii pacjenta',
  AddPatientSpeechTherapy:
    'Nie udało się zaktualizować notatek terapii logopedycznej pacjenta',
  EditPatientSpeechTherapy:
    'Nie udało się zaktualizować notatek terapii logopedycznej pacjenta',
  CreateGuardian: 'Nie udało się utworzyć opiekuna',
  DeactivateGuardian: 'Nie udało się dezaktywować opiekuna',
  EditGuardian: 'Nie udało się zaktualizować opiekuna',
  EditPatientAddress: 'Nie udało się zaktualizować adresu pacjenta',
  EditPatientGuardianAddress:
    'Nie udało się zaktualizować adresu opiekuna pacjenta',
  EditPractice: 'Nie udało się zaktualizować gabinetu',
  AddRoom: 'Nie udało się utworzyć pokoju',
  DeleteRoomPreferredEmployees: 'Nie udało się zaktualizować pokoju',
  DeleteRoomRestrictedServices: 'Nie udało się zaktualizować pokoju',
  EditRoom: 'Nie udało się zaktualizować pokoju',
  CreateService: 'Nie udało się utworzyć usługi',
  EditService: 'Nie udało się zaktualizować usługi',
  DeactivateService: 'Nie udało się dezaktywować usługi',
  DeactivateServices: 'Nie udało się dezaktywować usług',
  AssignEmployeesToService: 'Nie udało się przypisać pracowników do usługi',
  DeactivateUser: 'Nie udało się dezaktywować użytkownika',
  UpdateUserSettings: 'Nie udało się zaktualizować ustawień użytkownika',
  ConfirmMeetingRequest:
    'Nie udało się potwierdzić wizyty. Wybrany teraupeuta ma już o tej godzinie spotkanie, lub pokój jest zajęty',
  // QUERIES
  GetEvent: 'Nie udało się pobrać spotkania',
  GetEventDetails: 'Nie udało się pobrać szczegółów spotkania',
  GetEvents: 'Nie udało się pobrać spotkań',
  GetPaginatedEvents: 'Nie udało się pobrać spotkań',
  GetEmployees: 'Nie udało się pobrać pracowników',
  GetGroups: 'Nie udało się pobrać grup',
  GetCouples: 'Nie udało się pobrać par',
  GetPatients: 'Nie udało się pobrać pacjentów',
  GetPatientDetails: 'Nie udało się pobrać szczegółów pacjenta',
  GetPracticeDetails: 'Nie udało się pobrać szczegółów gabinetu',
  GetRooms: 'Nie udało się pobrać pokoi',
  GetServices: 'Nie udało się pobrać usług',
}
